// extracted by mini-css-extract-plugin
export default {"app":"styles_app__CBaBD","light":"styles_light__At70J","dark":"styles_dark__89MWX","inner":"styles_inner__BP2qD","fullWidthInner":"styles_fullWidthInner__AHEJt"};